import store from "@/store";
import request from "@/utils/request";

//권한 목록
export async function getSsoRoleList(params) {
    console.log("@@ get list : getSsoRoleList");
    let result = request.get("/api/sso/ssoRole/",{params});
    return result;
}

// 권한 상세
export async function getSsoRoleItem(roleSeq) {
    console.log("@@ get item : getSsoRoleItem");
    let result = request.get(`/api/sso/ssoRole/detail/${roleSeq}`);
    return result;
}

// 권한 등록/수정
export async function saveSsoRole(params) {
    console.log("@@ post save : saveSsoRole");
    let result = request.post(`/api/sso/ssoRole/`,params);
    return result;
}

export async function deleteSsoRole(params) {
    console.log("@@ delete : deleteSsoRole");
    let result = request.delete(`/api/sso/ssoRole/${params.roleSeq}`,{params});
    return result;
}
